import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=3ca6a180&scoped=true&"
import script from "./BaseInputNumber.vue?vue&type=script&async=true&lang=js&"
export * from "./BaseInputNumber.vue?vue&type=script&async=true&lang=js&"
import style0 from "./BaseInputNumber.vue?vue&type=style&index=0&id=3ca6a180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6a180",
  null
  
)

export default component.exports